import uuid from 'uuid-random';
import { storageService } from 'js/services/storage.service';

export const requesterUUID = uuid();
export const TRANSACTION_HANDLER_STORAGE_PREFIX = 'portal-geocomply-';

export const retrieveHandlerUUID = () => requesterUUID;

export const retrieveTransactionHandlerUUID = (transactionId) => {
    return storageService.local.getItem(`${TRANSACTION_HANDLER_STORAGE_PREFIX}${transactionId}`);
};

export const setTransactionHandlerUUID = (transactionId) => {
    storageService.local.setItem(`${TRANSACTION_HANDLER_STORAGE_PREFIX}${transactionId}`, requesterUUID);
};

export const unsetTransactionHandlerUUID = (transactionId) => {
    storageService.local.removeItem(`${TRANSACTION_HANDLER_STORAGE_PREFIX}${transactionId}`);
};
